export default __webpack_public_path__ + "static/media/patron-fondo.73199e4a.png";